export const getSavedLocation = state => state.settings.location;